import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Navbar, NavItem, Nav, NavDropdown, MenuItem, Modal } from 'react-bootstrap'
import { NavLink, Link, withRouter } from 'react-router-dom'
import './style.css'

const pkg = require('../../package.json')
const brandLogo = require("../static/images/gr_wide_logo_no_date.png")

const clearLocalStorage = () => {
  /// IF 'REMEMBER ME' WAS CHACKED UPON LOGIN THE USERNAME WILL REMAIN
  /// IN LOCAL STORAGE
  let rememberMe = ""
  if(localStorage.getItem("rememberMe")) rememberMe = localStorage.getItem("rememberMe")
  localStorage.clear()
  if(rememberMe){
    localStorage.setItem("rememberMe", rememberMe)
  }
}

const TopNav = (props) => {
  const [showCertinaGuidelinesModal, toggleShowCertinaGuidelinesModal] = useState(false)

  // let unreadCount = 0
  // if (props.notifications && props.notifications.unread_count) {
  //   unreadCount = props.notifications.unread_count
  // }
  if (localStorage.getItem("token")) {
    return (
      <div>
        <Navbar inverse fluid="true" collapseOnSelect id="TopNav">
          <Navbar.Header>
            <Navbar.Brand>
              <NavLink
                title={pkg.version}
                style={{ paddingRight: '25px' }}
                to="/"
              >
                PTOR
              </NavLink>
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>

          <Navbar.Collapse>
            <Nav>
              {/* <NavItem componentClass="span">
                <NavLink to="/org-chart">
                  Org Chart
                </NavLink>
              </NavItem> */}

              <NavItem componentClass="span">
                <NavLink to="/publications">
                  Publication Tracker
                </NavLink>
              </NavItem>

              <NavItem
                href="https://scientific-lexicon.gens1.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                SciLex
              </NavItem>

              <NavItem componentClass="span">
                <NavLink to="/data-access-request">
                  Data Access Request
                </NavLink>
              </NavItem>

              <NavItem componentClass="span">
                <NavLink to="/trainings">
                  QMS Training
                </NavLink>
              </NavItem>

              <NavItem componentClass="span">
                <NavLink to="/sap-repository">
                  SAP Repository
                </NavLink>
              </NavItem>

              <NavItem
                href="https://genesisrg.sharepoint.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                GRG Sharepoint
              </NavItem>

              {/*<NavItem*/}
              {/*  href="https://wiki.gens1.com/"*/}
              {/*  target="_blank"*/}
              {/*  rel="noopener noreferrer"*/}
              {/*>*/}
              {/*  GRG Wiki*/}
              {/*</NavItem>*/}
            </Nav>

            <Nav className='pullRight'>
              {/* User dropdown */}
              <NavDropdown
                id="user-dropdown"
                className="basic-nav-dropdown"
                title={
                    props.user.first_name ?
                    <span>
                      { props.user.first_name }
                      {/* { unreadCount ?
                        <div id="notification-circle">&nbsp;</div>
                          :
                        null
                      } */}
                    </span>
                    :
                    "Anonymus"
                  }
                >
                  { props.user.is_qms_training_manager &&
                    <NavItem componentClass="span">
                      <Link to="/manager/qms-training/trainings">
                        QMS Training Manager
                      </Link>
                    </NavItem>
                    }
                {props.user.is_manager ?
                  <div>
                    {/* <NavItem
                      href="https://us-east-1.online.tableau.com/#/site/genesisrg/workbooks/628971/views"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Analytics
                    </NavItem> */}
                    <NavItem componentClass="span">
                      <Link to="/manager">
                        Manage Data
                      </Link>
                    </NavItem>
                    { props.user.is_data_access_request_manager &&
                      <NavItem componentClass="span">
                        <Link to="/manager/data-access-request">
                          Data Access Request Manager
                        </Link>
                      </NavItem>
                    }
                    <MenuItem divider />
                  </div>
                  :
                  null
                }
                {/* <NavItem componentClass="span">
                  <Link id="user-name" to="/notifications">
                    Notifications
                    &nbsp;
                    <Badge
                      style={unreadCount ? {backgroundColor: "#FF804D"} : null}
                    >
                      { unreadCount }
                    </Badge>
                  </Link>
                </NavItem> */}
                <NavItem componentClass="span">
                  <Link id="user-name" to="/user-settings">
                    Settings
                  </Link>
                </NavItem>
                <MenuItem divider />
                <NavItem componentClass="span" onClick={ clearLocalStorage }>
                  <Link to="/">Log Out</Link>
                </NavItem>
              </NavDropdown>

              <NavItem
                componentClass="span"
                style={{ paddingTop:"7px", paddingLeft: '20px', cursor:"default" }}
                id="genesis-logo"
              >
                <img
                  width="100"
                  onClick={() => window.open("https://genesisrg.com/")}
                  src={ brandLogo }
                  alt="logo"
                />
              </NavItem>
            </Nav>

          </Navbar.Collapse>
        </Navbar>
        <br/>
        <br/>
        <br/>
        <Modal
          bsSize="lg"
          show={ showCertinaGuidelinesModal }
          onHide={ () => toggleShowCertinaGuidelinesModal(false) }
        >
          <Modal.Header closeButton><Modal.Title>Certinia Time Reporting Guidelines</Modal.Title></Modal.Header>
          <Modal.Body className="certina-guidelines-modal">
            <iframe
              title="Time Report Guidelines"
              src={require("../static/pdfs/time_reporting_guidelines_and_introduction_to_certinia_vf.pdf")}
              width="100%"
              height="100%"
            />
          </Modal.Body>
        </Modal>
      </div>
    )
  } else {
    return null
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.manageLogin.user,
    notifications: state.manageNotifications.notifications,
  }
}

export default withRouter(connect(mapStateToProps)(TopNav))



// WEBPACK FOOTER //
// ./src/NavBar/TopNav.js